import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'
import Select from 'react-select'
import HomeMini from '../../components/HomeMini';
import axiosConfig from '../../config/axiosConfig'
import GroupVRNSelect from '../../containers/comps/GroupVRNSelectContainer'


const firstDate = new Date();
const currentDate = new Date();

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? 'yellow' : 'white'
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '50px',
        borderColor: 'Yellow'

    })
}


function Iframe(props) {
    console.log("URL Calling : ", props.src)
    return (
        <div>
            <iframe src={props.src} height={props.height} width={props.width} allowFullScreen={true} style={{ border: 0 }} />
        </div>
    )
}

class HSSEDashboardSummary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showReport: false,
            firstDay: new Date(firstDate.getFullYear(), firstDate.getMonth(), 1),
            fromDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2).toISOString().substring(0, 10), //new Date(date.getFullYear(), date.getMonth(), 1);
            toDate: new Date().toISOString().substring(0, 10),
            "OVER_SPEEDING": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 1
            },
            "HARSH_BRAKING": {
                currentMonthReading: 59,
                previosMonthReading: 60,
                percentDifferent: 1
            },
            "HARSH_TURN": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 1
            },
            "SEAT_BELT_VIOLATION": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 1
            },
            "IDLING_TIME": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 1
            },
            "HARSH_ACCELERATION": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 1
            },
            "HSSE_SCORE": {
                currentMonthReading: 0,
                previosMonthReading: 0,
                percentDifferent: 0
            },

            //reportBaseURL: 'http://localhost:40383/Charts?',
            reportBaseURL: 'https://shelltelematics.pk/TELEMATICSREPORTINGSERVICE/Charts?',
            reportExtraParams: '&rs:Command=Render&rc:Parameters=false&',
            reportViewType: '/SSSAS_TabularReports/',
            VRNMappingMasterId: '',
            VRNGroupMasterId: '',

        };

    }

    getHSSEAnalyticsData() {
        axiosConfig.post('Portal/GetFuelingSafetyEventData', {
            "UserAccountBranchID": localStorage.getItem('selectedBranch'),
            "SearchTypeId": 1,
            "CardMappingMasterId": 0,
            "VRNGroupMasterId": 0,
            "StartTime": this.state.fromDate,
            "EndTime": this.state.toDate,
            // "NoOfRecords":10
        })
            .then((res) => {
                for (var i = 0; i < res.data.eventAnalytics.length; i++) {
                    this.setState((prevState) => ({
                        [res.data.eventAnalytics[i].event]: {
                            currentMonthReading: res.data.eventAnalytics[i].currentMonthReading,
                            percentDifferent: res.data.eventAnalytics[i].percentDifferent,
                            previosMonthReading: res.data.eventAnalytics[i].previosMonthReading,
                        }
                    }));
                }
            })
            .catch(console.error)
            .finally(() => {
            });
    }

    componentDidMount() {
        this.getHSSEAnalyticsData();
    }

    render() {

        return (

            <div>

                <Container>
                    <Row>
                        <Card style={{ width: '100%', height: '50px' }}>
                            <Card.Body>
                                <a href="./MyReports" style={{ color: 'blue' }}>
                                    <p>For more details on your fleet’s performance, click here to visit My Reports</p>
                                </a>
                            </Card.Body>
                        </Card>

                    </Row>

                    <Row>
                        <Col xs={2} >
                            <div style={{ height: "180px" }} >
                                <Card className="text-center bg-shell h-100" style={{ boxShadow: '0px 0px 10px 2px rgba(64, 64, 64, 0.6)' }}>
                                    <div className="card-content mt-6" style={{ margin: 'auto' }}>
                                        <Card.Header className="text-center">
                                        </Card.Header>

                                        <Card.Body>
                                            <div className="avatar avatar_shell bg-rgba-shell p-50 m-0 mb-1">
                                                <i className="fa fa-exclamation-triangle font-medium-5" />
                                            </div>
                                            <h2 className="text-bold-700" style={{ color: '#595959', margin: 'auto', fontSize: '18px' }}>HSSE</h2>
                                        </Card.Body>
                                    </div>
                                </Card>
                            </div>
                        </Col>
                        <Col>
                            <CardDeck>
                                <HomeMini quantityPrice={this.state.HSSE_SCORE.currentMonthReading} Icon="fa fa-truck text-warning font-medium-5" percentage="-1" description="HSSE Score" cssName="avatar bg-rgba-warning p-50 m-0 mb-1" />
                                <HomeMini quantityPrice={this.state.HARSH_BRAKING.currentMonthReading} Icon="fa fa-empire text-success font-medium-5" percentage="-1" description="Incidents of Harsh Braking" cssName="avatar bg-rgba-success p-50 m-0 mb-1" />
                                <HomeMini quantityPrice={this.state.HARSH_ACCELERATION.currentMonthReading} Icon="fa fa-road text-primary font-medium-5" percentage="-1" description="Incidents of Harsh Acceleration" cssName="avatar bg-rgba-primary p-50 m-0 mb-1" />
                                <HomeMini quantityPrice={this.state.HARSH_TURN.currentMonthReading} Icon="fa fa-eercast text-info font-medium-5" percentage="-1" description="Incidents of Harsh Turn" cssName="avatar bg-rgba-info p-50 m-0 mb-1" />
                                <HomeMini quantityPrice={this.state.OVER_SPEEDING.currentMonthReading} Icon="fa fa-car text-danger font-medium-5" percentage="-1" description="Incidents of Overspeeding" cssName="avatar bg-rgba-danger p-50 m-0 mb-1" />
                            </CardDeck>
                            {/* <CardDeck>

                                <HomeMini quantityPrice={this.state.SEAT_BELT_VIOLATION.currentMonthReading} Icon="fa fa-openid text-primary font-medium-5" percentage="-1" description="Incidents of Seatbelt Violations" cssName="avatar bg-rgba-primary p-50 m-0 mb-1" />
                                <HomeMini quantityPrice="0" Icon="fa fa-bitbucket text-danger font-medium-5" percentage="-1" description="Incidents of Battery Tamper" cssName="avatar bg-rgba-danger p-50 m-0 mb-1" />
                                <HomeMini quantityPrice="0" Icon="fa fa-eercast text-success font-medium-5" percentage="-1" description="Incidents of Contiuous Driving > 3 Hours" cssName="avatar bg-rgba-success p-50 m-0 mb-1" />
                                <HomeMini quantityPrice="0" Icon="fa fa-tint text-warning font-medium-5" percentage="-1" description="Incidents of Rest Hours <15 Mins" cssName="avatar bg-rgba-warning p-50 m-0 mb-1" />
                                <HomeMini quantityPrice={this.state.IDLING_TIME.currentMonthReading} Icon="fa fa-road text-info font-medium-5" percentage="-1" description="Idling Hours" cssName="avatar bg-rgba-info p-50 m-0 mb-1" />
                            </CardDeck> */}

                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default HSSEDashboardSummary;
